export default "<app-nav-bar></app-nav-bar>\r\n  \r\n<router-outlet></router-outlet>"